<template>
  <router-view />
</template>

<script setup lang="ts">
// App 现在只是路由的容器
</script>
